/* ---------- Hero: the headline and the company in three figures ---------- */
.hero {
  /* Same overlap as the home hero: cancel the flow space the sticky header reserves. */
  margin-top: calc(-1 * (var(--header-h) + 2 * var(--header-margin)));
  padding-block: calc(var(--header-h) + 2 * var(--header-margin) + var(--sp-12)) var(--sp-16);
  background: var(--surface-alt);
}
.heroTitle {
  max-width: 16ch;
  /* Room under the breadcrumb, which the dropped eyebrow label used to provide. */
  margin-top: var(--sp-6);
  font-size: clamp(2.4rem, 3.4vw + 1rem, 4.25rem);
  line-height: 1.04;
  letter-spacing: -0.035em;
  text-wrap: balance;
}
.heroLead {
  max-width: 40rem;
  margin-top: var(--sp-5);
  font-size: var(--fs-lg);
  color: var(--text);
}
.figures {
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-3) var(--sp-10);
  max-width: 48rem;
  margin-top: var(--sp-10);
  padding-top: var(--sp-5);
  border-top: 1px solid var(--border-strong);
  color: var(--text-muted);
}
.figures strong {
  margin-right: 0.3em;
  font-family: var(--font-display);
  font-size: var(--fs-2xl);
  font-weight: 700;
  letter-spacing: var(--tracking-heading);
  color: var(--text-strong);
}

/* ---------- People ---------- */
.people {
  display: grid;
  gap: var(--sp-10) var(--sp-6);
}
.leadGrid {
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 17rem), 1fr));
  gap: var(--sp-10) var(--sp-8);
}
.memberGrid {
  grid-template-columns: repeat(auto-fit, minmax(min(100%, 12.5rem), 1fr));
}
.compactGrid {
  grid-template-columns: repeat(auto-fill, minmax(min(100%, 9.5rem), 1fr));
  gap: var(--sp-8) var(--sp-5);
}
@media (min-width: 64rem) {
  .leadGrid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
/* The compact groups run 80vw wide, centred on the page, with fixed-width cards and the
   space between them shared out across the row. The 2rem minimum gap is wider than a
   long one-line name's overflow (PersonCard), so a row drops a card before names touch. */
@media (min-width: 48rem) {
  .compactGrid {
    width: 80vw;
    margin-inline: calc(50% - 40vw);
    grid-template-columns: repeat(auto-fit, 9.5rem);
    column-gap: 2rem;
    justify-content: space-between;
  }
}

/* ---------- Phones: two to a row ---------- */
@media (max-width: 47.99rem) {
  .memberGrid,
  .compactGrid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: var(--sp-8) var(--sp-4);
  }
}
